import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { ForgetPassword } from 'src/app/models/ForgetPassword.model';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import Helper from 'src/app/Util/helper';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthUtils } from 'src/app/Util/auth-utils';
import { environment } from 'src/environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.sass']
})

export class ForgotPasswordComponent implements OnInit {

  private unsubscribe$ = new Subject<void>();
  emailFormGroup: FormGroup;
  isSendingResetLink = false;
  isResetLinkSent = false;
  emailFormSubmitted = false;
  email: string = '';

  constructor(
    private notificationSvc: CloudNotificationService,
    private authSvc: AuthenticationService,
    private formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly location:Location,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getEncodedEmailFromQuery();
    this.initializeForm();
  }

  private initializeForm(): void {
    this.emailFormGroup = this.formBuilder.group({ email: [this.email, [Validators.required, Validators.email]] })
  }

  private getEncodedEmailFromQuery(): void {

    this.route.queryParams.subscribe(queryParams => {

      if (queryParams.email) {
        this.email = AuthUtils.decodeFromBase64(queryParams.email)

      } else {
        this.email = '';
      }

    })

  }

  get emailForm() {
    return this.emailFormGroup.controls;
  }

  onEmailFormSubmit() {
    this.emailFormSubmitted = true;
    if (this.emailFormGroup.invalid) return;
    const encoded_email = AuthUtils.encodeToBase64(this.emailForm.email.value);
    this.sendResetPasswordLink(encoded_email);
  }

  private sendResetPasswordLink(encoded_email: string): void {

    this.isSendingResetLink = true

    this.authSvc.forgotPassword(encoded_email).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (message) => {
        this.isSendingResetLink = false
        this.isResetLinkSent = true
        this.notificationSvc.createToastNotification('Reset', message, CloudNotificationStyle.success);
      },

      error: (error: HttpErrorResponse) => {
        this.isSendingResetLink = false
        this.notificationSvc.createToastNotification('Reset', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
      }

    })

  }

  navigateToLogin(e: Event = null): void {
    e?.preventDefault();
    this.location.back()
  }

}
